import { render } from "./TrekRecaptcha.vue?vue&type=template&id=a67d6b70"
import script from "./TrekRecaptcha.vue?vue&type=script&lang=js"
export * from "./TrekRecaptcha.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__